/**
 * Platform access is a tenant boundary, not an email- or permission-based UI
 * preference. A genuine platform administrator is a super_admin whose account
 * is deliberately not attached to any organization.
 */
export const isPlatformAdminUser = (user) => (
  user?.role === 'super_admin' && user?.organizationId === null
);

export default isPlatformAdminUser;
